import React, { useEffect, useState } from 'react'
import { useProcessBatchMutation } from '../../../../api-services/financial/currencyExchangeApi'
import { RtkQueryHelper } from '../../../../api-services/shared/RtkQueryHelper'
import { useAppDispatch } from '../../../../app/hooks'
import InProgressComponent from '../../../components/ui-widgets/InProgressComponent'
import { setNotification } from '../../../components/ui-widgets/uiWidgetsSlice'
import { type BatchIdActionProps } from './ExchangeInstructionBatchPage'
import { Box, Button, TextField } from '@mui/material'

const ProcessBatch: React.FC<BatchIdActionProps> = ({ batch }: BatchIdActionProps) => {
  const dispatch = useAppDispatch()
  const [exchangeRate, setExchangeRate] = useState<number | null>(batch.exchangeRate)
  const [fieldError, setFieldError] = useState<boolean>(false)

  const [apiProcessBatchTrigger, apiProcessBatchResult] = useProcessBatchMutation()
  const handleClick = async (): Promise<void> => {
    if (exchangeRate === null) {
      setFieldError(true)
    } else {
      const choice = window.confirm(
        'Are you sure you want to process this batch? This will post transactions to members wallets and create disbursement instructions.'
      )
      if (choice) {
        await apiProcessBatchTrigger({ batchId: batch.batchId, exchangeRate })
      }
    }
  }

  useEffect(() => {
    if (apiProcessBatchResult.isSuccess) {
      dispatch(setNotification({ open: true, severity: 'success', message: `Batch ${apiProcessBatchResult.data.batchId} processed.` }))
    }

    if (apiProcessBatchResult.isError) {
      dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(apiProcessBatchResult.error) }))
    }
  }, [apiProcessBatchResult.isSuccess, apiProcessBatchResult.isError])

  return (
    <Box sx={{ display: 'flex' }} alignItems="center" >
      <TextField
        label={'Exchange Rate'}
        type={'number'}
        variant="outlined"
        sx={{ width: '150px', mr: 2 }}
        placeholder={'Exchange Rate'}

        error={fieldError}
        helperText={''}
        value={exchangeRate}
        onChange={(event: any) => {
          setFieldError(false)
          setExchangeRate(event.target.value)
        }}
        disabled={!batch.processable || apiProcessBatchResult.isLoading}
      />
      <Button sx={{ mr: 2 }} type={'button'} variant={'contained'} disabled={!batch.processable || apiProcessBatchResult.isLoading} onClick={handleClick}>
        Post to Wallets
      </Button>
      {apiProcessBatchResult.isLoading && <InProgressComponent/>}
    </Box>
  )
}

export default ProcessBatch
